import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";
import { IRequirementDefinitionUpdate } from "@wingspanhq/payments/dist/interfaces/requirement";

export const updateRequirementDefinition = async (
  id: string,
  payload: IRequirementDefinitionUpdate & { versionNote?: string } //TODO: remove
): Promise<IRequirementDefinitionResponse> => {
  const response = await servicePayments.patch(
    `/requirement-definition/${id}`,
    payload
  );
  return response.data;
};
